import { Component, OnInit } from '@angular/core';
import {
  EnvironmentData,
  EnvironmentService,
} from '../../services/environment.service';

@Component({
  selector: 'app-app-footer',
  templateUrl: './app-footer.component.html',
  styleUrls: ['./app-footer.component.css'],
})
export class AppFooterComponent implements OnInit {
  env: EnvironmentData;

  constructor(private envService: EnvironmentService) {
    this.envService.getEnvironment().subscribe((env) => {
      this.env = env;
    });
  }

  ngOnInit(): void {}
}
